import { basicEnum } from "./base";

export const FinalizationStepStatusEnum = basicEnum([
    {
        label: "EMPTY",
        value: "E",
    },
    {
        label: "INITIALIZED",
        value: "I",
    },
    {
        label: "SIGNED",
        value: "S",
    },
]);

export namespace FinalizationStepStatusEnum {
    export type Labels = (typeof FinalizationStepStatusEnum)["labels"][number];
    export type Values = (typeof FinalizationStepStatusEnum)["values"][number];
}
